import { meSessionQueryOptions } from '@features/me/queries';
import { normalizePermission } from '@features/rbac/permissions';
import { overviewPermission } from '@features/teacher-portal-overview/api';
import { TeacherPortalOverviewDashboard } from '@features/teacher-portal-overview/components/TeacherPortalOverviewDashboard';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/teacher-portal/overview/registers',
)({
    beforeLoad: async ({ context }) => {
            const session = await context.queryClient.ensureQueryData(
                meSessionQueryOptions(),
            );
            if (
                session.viewMode !== "staff" ||
                !session.permissions.some(
                    (p) => normalizePermission(p) === overviewPermission,
                )
            ) {
                throw redirect({ to: "/unauthorised" });
            }
        },
        component: TeacherPortalOverviewDashboard,
        staticData: { crumb: { label: "Overview Dashboard" } },
})
